<div class="modal-header" *ngIf="!!availability">
  <div class="modal-title" id="modal-basic-title">
    <h4 translate>FUTURE</h4>
    <div class="fs-6 fw-normal">
      <div>
        <span translate>AVAILABILITY</span>:
        <span class="fw-bold">{{ availability.currentAvailability || 0 | number }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</span>
      </div>
      <div>
        <span translate>MAX_FUTURE</span>:
        <ng-container *ngIf="availability?.maxFutureStock === 100000; else showMaxFutureStock">
          <span class="fw-bold" translate>STOCK_REPLENISHMENT</span>
        </ng-container>
        <ng-template #showMaxFutureStock>
          <span class="fw-bold">{{ availability.maxFutureStock || 0 | number }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</span>
        </ng-template>
      </div>
      <div>
        <span translate>STOCK</span>:
        <span class="fw-bold">{{ availability.currentStock || 0 | number }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</span>
      </div>
    </div>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <lib-gung-tabset [destroyOnHide]="false">
    <lib-gung-tab title="{{ 'BREAKDOWN' | translate }}">
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th scope="col" translate>DATE</th>
              <th scope="col" translate>ITEMS_AVAILABLE</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let availabilitie of availability.extra.availabilities | keyvalue">
              <td>{{ parseDate(availabilitie.key) | date: 'shortDate' }}</td>
              <td>
                <ng-container *ngIf="reservedOn(availabilitie.key) > 0 && availabilitie.value !== 100000; else plainValue">
                  {{ availabilitie.value | number }}
                  <span class="text-muted"
                    >({{ availableWithoutReservedOn(availabilitie.key, availabilitie.value) | number }}
                    + {{ reservedOn(availabilitie.key) | number }}
                    <span translate>BLOCK_ORDER_RESERVED</span>)</span
                  >
                </ng-container>
                <ng-template #plainValue>
                  {{
                    availabilitie.value > 0
                      ? availabilitie.value === 100000
                        ? ('STOCK_REPLENISHMENT' | translate)
                        : (availabilitie.value | number)
                      : ('NO_AVAILABILITY' | translate)
                  }}
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab *ngIf="availability.extra.igr">
      <ng-template libGungTabTitle>{{ 'PURCHASE_ORDER_DETAILS' | translate }}</ng-template>
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th scope="col" translate>ORDER_SLASH_ROW</th>
              <th scope="col" translate>QUANTITY_REMAINING</th>
              <th scope="col" translate>DELIVERY_DATE</th>
              <th scope="col" translate>SEASON</th>
              <th scope="col" translate>NOTE</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of availability.extra.igr">
              <td>{{ row.ONR }}/{{ row.RDC }}</td>
              <td>{{ parseFloat(row.ORA) - parseFloat(row.TLA) | number }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</td>
              <td>{{ row.LDT }}</td>
              <td>{{ row.IGA_SES }}</td>
              <td>{{ row.ignored }}</td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab title="{{ 'CUSTOMER_ORDER_DETAILS' | translate }}" *ngIf="availability.extra.ogr">
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th scope="col" translate>ORDER_SLASH_ROW</th>
              <th scope="col" translate>QUANTITY_REMAINING</th>
              <th scope="col" translate>DELIVERY_DATE</th>
              <th scope="col" translate>SEASON</th>
              <th scope="col" translate>NOTE</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of availability.extra.ogr">
              <td>{{ row.ONR }}/{{ row.RDC }}</td>
              <td>{{ parseFloat(row.ORA) - parseFloat(row.TLA) | number }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</td>
              <td>{{ row.LDT }}</td>
              <td>{{ row.OGA_SES }}</td>
              <td>{{ row.ignored }}</td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>

<div class="modal-footer"></div>
